export default "__VITE_ASSET__2UzWD7j3__"